<template>
  <div class="container">
    <label v-for="(item, index) in showList" @click="del(index)" :key="item.id">
      <a-tag color="blue"> {{ item.nickname }}所在部门{{ item.departmentUserCounts > 0 ? `(${item.departmentUserCounts})` : '' }} </a-tag>

      <a-icon class="close-icon" type="close"></a-icon>
    </label>

    <a-dropdown :trigger="['click']" v-model="visible">
      <a-button type="primary" size="small" shape="circle" icon="edit" />

      <project-member-menu
        v-if="visible"
        ref="projectMemberMenu"
        slot="overlay"
        @chose="handleChose"
        :userlist="userList"
        @close="handleClose"
      ></project-member-menu>
    </a-dropdown>
  </div>
</template>
<script>
import { queryDepartmentUserCountsByUserId } from '@/api/common';
import selectMember from '@/components/project/selectMember';
import projectMemberMenu from '@/components/project/projectMemberMenu';
export default {
  components: {
    projectMemberMenu
  },
  data() {
    return {
      visible: false,
      userList: [],
      showList: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.userList = this.showList.map(item => ({ ...item }));
      }
    }
  },
  methods: {
    handleVisibleChange(visible) {
      this.visible = visible;
    },
    handleChose(userList) {
      this.userList = userList;
    },
    handleClose() {
      this.showList = this.userList.map(item => ({ ...item }));
      this.showList.forEach(async (i, index) => {
        queryDepartmentUserCountsByUserId(i.id).then(res => {
          console.log('res', res);
          this.$set(this.showList[index], 'departmentUserCounts', res.data);
        });
      });

      this.$emit(
        'change',
        this.userList.map(item => ({ ...item }))
      );
      this.visible = false;
    },
    del(index) {
      this.showList.splice(index, 1);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding-left: 10px;

  --hover-color: #f5222d;
  label {
    position: relative;
    margin: 0 5px;
    cursor: pointer;
    span {
      margin: 0;
    }
    .close-icon {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: var(--hover-color);
    }
    &:hover {
      .close-icon {
        display: block;
      }
      // border: 1px solid var(--hover-color);
      // border-radius: 5px;
      span {
        opacity: 0.2;
        color: rgba(245, 34, 45, 0.4);
        background: #fff1f0;
        border-color: #f5222d;
      }
    }
  }
}
</style>
